module.exports = __webpack_public_path__ + "static/media/yb.3af835d8.svg";